// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__27rOG","inputDescription":"styles_inputDescription__2PjlG"};